import React from 'react';
import { createRoot } from 'react-dom/client';
import { ChatWidget } from './components/ChatWidget/ChatWidget';
import type { ChatWidgetProps } from './types';

/**
 * Interface global para configuração do widget
 */
declare global {
  interface Window {
    ChatWidgetConfig?: Partial<ChatWidgetProps>;
    initChatWidget?: (config: Partial<ChatWidgetProps>) => void;
  }
}

/**
 * Inicializa o widget no DOM
 */
function initChatWidget(config: Partial<ChatWidgetProps>) {
  // Procura por elemento com ID específico ou cria um novo
  let container = document.getElementById('chat-widget-root');

  if (!container) {
    container = document.createElement('div');
    container.id = 'chat-widget-root';

    // Se mode for fullscreen, posiciona o container
    // Se mode for window, o ChatWidget se auto-posiciona
    if (config.mode === 'fullscreen') {
      container.style.cssText = `
        position: fixed;
        bottom: 20px;
        right: 20px;
        z-index: 9999;
      `;
    }

    document.body.appendChild(container);
  }

  // Valida configuração mínima
  if (!config.loadMessagesUrl || !config.sendMessageUrl) {
    console.error('[ChatWidget] Erro: loadMessagesUrl e sendMessageUrl são obrigatórios');
    return;
  }

  // Renderiza o widget
  const root = createRoot(container);
  root.render(<ChatWidget {...config as ChatWidgetProps} />);
}

// Exporta função globalmente
if (typeof window !== 'undefined') {
  window.initChatWidget = initChatWidget;

  // Auto-inicializa se configuração estiver disponível
  if (window.ChatWidgetConfig) {
    // Aguarda DOM estar pronto
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initChatWidget(window.ChatWidgetConfig!);
      });
    } else {
      initChatWidget(window.ChatWidgetConfig);
    }
  }
}

export { initChatWidget };
